
export const getRecommendedItems = (menu) => {

    const result = [];

    let promoted = menu.sections
        .filter(x => x.records?.length > 0)
        .map(x => x.records.filter(r => r.promoted?.enabled))
        .filter(x => x.length > 0)
        .reduce((a,b) => [...a, ...b], []);

    if (promoted && promoted.length > 1) {

        const idx1 = Math.round(Math.random() * (promoted.length-1));
        result.push(promoted[idx1]);

        let idx2 = Math.round(Math.random() * (promoted.length-1));
        let attempt = 1;

        while (idx1 === idx2 && attempt < 10) {
            idx2 = Math.round(Math.random() * (promoted.length-1));
        }

        if (idx1 !== idx2) {
            result.push(promoted[idx2]);
        }
    }
    else if (promoted && promoted.length === 1) {

        result.push(promoted[0]);
    }

    return result;
};
